
import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import IntegrationsHero from './components/IntegrationsHero';
import FeaturedIntegrations from './components/FeaturedIntegrations';
import IntegrationGrid from './components/IntegrationGrid';
import DeveloperCTA from './components/DeveloperCTA';

export default function Integrations() {
  const [searchQuery, setSearchQuery] = useState('');

  return (
    <div className="min-h-screen bg-white font-['Montserrat']">
      <Header />

      <IntegrationsHero searchQuery={searchQuery} onSearchChange={setSearchQuery} />

      {/* Only show featured integrations if no search */}
      {!searchQuery && <FeaturedIntegrations />}

      <IntegrationGrid searchQuery={searchQuery} />

      <DeveloperCTA />

      {/* Final CTA */}
      <section className="py-20 bg-gradient-to-br from-[#22577A] to-[#38a3a5]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            Ready to Connect Your Tools?
          </h2>
          <p className="text-xl text-white/90 mb-8">
            Start using AgenticAI with all your favorite platforms today
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="#"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white text-[#22577A] rounded-lg font-semibold hover:shadow-xl transition-all cursor-pointer"
            >
              <i className="ri-rocket-line"></i>
              Start Free Trial
            </a>
            <a
              href="#contact"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 border-2 border-white text-white rounded-lg font-semibold hover:bg-white/10 transition-all cursor-pointer"
            >
              <i className="ri-customer-service-line"></i>
              Contact Sales
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
